var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 27 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.262 22.286c5.883 0 10.652-4.769 10.652-10.652C22.914 5.75 18.145.98 12.262.98c-5.883 0-10.653 4.77-10.653 10.653 0 5.883 4.77 10.652 10.653 10.652ZM25.61 24.982l-5.825-5.804",
  stroke: "currentcolor",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

export default SvgIconSearch;